module.exports = __webpack_public_path__ + "static/media/colorBridging3.cbcb83f9.jpg";